module.exports = __webpack_public_path__ + "img/grid-srp-preview-lincoln.c1152990.png";